export default __webpack_public_path__ + "static/media/arrow.34d50ca7.svg";